var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flightInfo"},[_c('AirportList',{attrs:{"locale":_vm.locale,"lang":_vm.lang,"list":_vm.airport}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }